import { render, staticRenderFns } from "./OrderDetail.vue?vue&type=template&id=12df23de&scoped=true"
import script from "./OrderDetail.vue?vue&type=script&lang=js"
export * from "./OrderDetail.vue?vue&type=script&lang=js"
import style0 from "./OrderDetail.vue?vue&type=style&index=0&id=12df23de&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12df23de",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/test-crmeb-admin-front-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('12df23de')) {
      api.createRecord('12df23de', component.options)
    } else {
      api.reload('12df23de', component.options)
    }
    module.hot.accept("./OrderDetail.vue?vue&type=template&id=12df23de&scoped=true", function () {
      api.rerender('12df23de', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/rsManagement/orderList2/components/OrderDetail.vue"
export default component.exports